












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Getter, Mutation } from 'vuex-class';
import { VuexMutation, PayFrequencyValues, Person, Output } from '@/types';
import CountUp from 'countup.js';
import _ from 'lodash';

@Component
export default class Tooltip extends Vue {
  @Prop({ type: String }) public id: string;
  @Prop({ type: String }) public placement: string;
  @Prop({ type: String }) public innerText: string;
  @Prop({}) public options: any;
  @Prop({}) public track: string[];
  @Prop({ type: String, default: 'content-changed' }) public changedDefault: string;

  public changedClass: string =  '';

  public get correctId(): string {
    return this.id ? this.id : _.uniqueId('tooltip');
  }

  public get selectorId(): string {
    return _.indexOf(this.correctId, '#') === 0 ? this.correctId : `#${this.correctId}`;
  }

  public get tippy(): any {
    return (this.$refs.tippy as any)._tippy;
  }

  public get opts(): any {
    const defaults = {
      html: this.selectorId,
      interactive: true,
      reactive: true,
      arrow: true,
      placement: this.placement,
      followCursor: false,
      theme: 'light-border',
    };

    return this.options ? _.defaultsDeep(this.options, defaults) : defaults;
  }
}
